/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ruian_LabelInputs */

const cs_ruian_label = /** @type {(inputs: Ruian_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledání adresy RÚIAN`)
};

const en_ruian_label = /** @type {(inputs: Ruian_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RÚIAN address search`)
};

/**
* | output |
* | --- |
* | "RÚIAN address search" |
*
* @param {Ruian_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ruian_label = /** @type {((inputs?: Ruian_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ruian_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ruian_label(inputs)
	return cs_ruian_label(inputs)
});